// Banana: an arc that turns the ball round (a "slide" curve under the placement point)
import { definePart } from '../core/registry';
import { shadowOn, shadowOff, DEG } from '../core/draw-helpers';
import type { Arc, Ctx2D, Placement } from '../core/types';

const ARC: Arc = { r: 95, a0: 20, a1: 160, n: 9, t: 16 };

export function drawBanana(ctx: Ctx2D, pl: { x: number; y: number; a?: number }, sel?: boolean) {
  const P = ARC, a = (pl.a || 0) * DEG;
  ctx.save(); ctx.translate(pl.x, pl.y); ctx.rotate(a); ctx.translate(0, -P.r * 0.55);
  shadowOn(ctx, 12, 6);
  ctx.lineCap = 'round';
  ctx.strokeStyle = '#E9B81C'; ctx.lineWidth = P.t + 8;
  ctx.beginPath(); ctx.arc(0, 0, P.r, P.a0 * DEG, P.a1 * DEG); ctx.stroke();
  shadowOff(ctx);
  ctx.strokeStyle = '#FFE066'; ctx.lineWidth = P.t + 2;
  ctx.beginPath(); ctx.arc(0, 0, P.r, P.a0 * DEG, P.a1 * DEG); ctx.stroke();
  ctx.strokeStyle = 'rgba(255,255,255,.6)'; ctx.lineWidth = 3;
  ctx.beginPath(); ctx.arc(0, 0, P.r - 5, (P.a0 + 8) * DEG, (P.a1 - 8) * DEG); ctx.stroke();
  // brown ends
  ctx.fillStyle = '#7A4B1E';
  [P.a0, P.a1].forEach(d => { ctx.beginPath(); ctx.arc(Math.cos(d * DEG) * P.r, Math.sin(d * DEG) * P.r, 5, 0, 7); ctx.fill(); });
  if (sel) { ctx.strokeStyle = '#fff'; ctx.lineWidth = 3; ctx.setLineDash([8, 6]); ctx.beginPath(); ctx.arc(0, 0, P.r + 20, P.a0 * DEG, P.a1 * DEG); ctx.stroke(); }
  ctx.restore();
}

export const banana = definePart({
  arc: ARC, rot: true, thumb: false,
  draw: (ctx, pl, sel) => drawBanana(ctx, pl, sel),
  icon: ctx => drawBanana(ctx, { x: 0, y: -8, a: 0 }),
  // tap on the arc itself (not inside it)
  hitTest(pl: Placement, w) {
    const P = ARC, a = (pl.a as number) * DEG;
    const cx = pl.x - Math.sin(a) * (-P.r * 0.55), cy = pl.y + Math.cos(a) * (-P.r * 0.55);
    const d = Math.hypot(w.x - cx, w.y - cy);
    return Math.abs(d - P.r) < 34 && Math.hypot(w.x - pl.x, w.y - pl.y) < P.r + 40;
  },
  menuTop: pl => pl.y - 80,
  intro(x, t, g, { fakeBall, arrow }) {
    drawBanana(x, { x: 230, y: 150, a: 0 });
    const k = t / 160, P = ARC;
    let bx, by;
    if (k < 0.25) { bx = 150; by = 20 + k / 0.25 * 110; }
    else if (k < 0.8) { const a = (160 - (k - 0.25) / 0.55 * 140) * DEG; bx = 230 + Math.cos(a) * (P.r - 26); by = 150 - P.r * 0.55 + Math.sin(a) * (P.r - 26); }
    else { const kk = (k - 0.8) / 0.2; bx = 310 + kk * 90; by = 130 - kk * 100; }
    if (k <= 1.05) g.ball(x, fakeBall(bx, by, 3, 0), 'hero', t);
    arrow(400, 110, 430, 40);
  },
});
